import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { AppConfig } from '../../app.config';
import { BaseService } from './baseService';
import { AppInsightService } from './app-insight.service';

@Injectable()
export class ResourceCenterService extends BaseService{
    constructor(protected http: HttpClient, protected config: AppConfig, protected appInsights: AppInsightService) {
        super(http, config, appInsights);
    }

    public createFolder(folderName:string, jursidiction): Promise<string> {
        var url = '/resource/CreateDirectory/' + jursidiction + '/'+ folderName;
        
        return this.httppost<any>(url, {});
    }

    public deleteFolder(folderName:string, jursidiction): Promise<string> {
        var url = '/resource/DeleteDirectory/' + jursidiction +'/'+ folderName;
        
        return this.httppost<any>(url, folderName);
    }

    public fetchResourceDetails(jurisdiction: string ): Promise<any> {
        return this.httpget<any>(`/resource/details?jurisdiction=${jurisdiction}`);
    }

    public deleteResource(resource: any, jursidiction: string) {
        return this.httppost<any>(`/resource/delete/${jursidiction}?resource=${resource}`, {}) ;
    }

    public downloadResource(resource: any, jursidiction: string): Promise<any> {
        return this.httpgetblob<any>(`/resource/download/?resource=${resource}&jurisdiction=${jursidiction}`);
    }
}

